import { render } from "./ServiceDetails2.vue?vue&type=template&id=6c29106e&scoped=true"
import script from "./ServiceDetails2.vue?vue&type=script&lang=js"
export * from "./ServiceDetails2.vue?vue&type=script&lang=js"

import "./ServiceDetails2.vue?vue&type=style&index=0&id=6c29106e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c29106e"]])

export default __exports__